"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _Constants = require("../../Constants");

var _AvatarContentHolder = _interopRequireDefault(require("./AvatarContentHolder"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  border-radius: 50%;\n  bottom: -1%;\n  color: ", ";\n  display: flex;\n  font-family: sans-serif;\n  font-size: 600%;\n  justify-content: center;\n  position: absolute;\n  right: -16%;\n  user-select: none;\n  width: 64%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SocialBadgeWrapper = (0, _styledComponents.default)('div').withConfig({
  displayName: "SocialBadge__SocialBadgeWrapper",
  componentId: "ulq22m-0"
})(_templateObject(), _colors.OLAF);

var SocialBadge = function SocialBadge(props) {
  var socialNetwork = props.socialNetwork;
  return _react.default.createElement(SocialBadgeWrapper, null, _react.default.createElement(_AvatarContentHolder.default, null, _react.default.createElement(_SVGIcon.default, {
    wrapperProps: {
      style: {
        backgroundColor: _Constants.SOCIAL_MAP[socialNetwork].color
      }
    },
    y: "70",
    icon: _Constants.SOCIAL_MAP[socialNetwork].icon
  })));
};

SocialBadge.propTypes = {
  socialNetwork: _propTypes.default.oneOf(Object.keys(_Constants.SOCIAL_MAP))
};
var _default = SocialBadge;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/UIAvatarDisplay/baseStyledComponents/SocialBadge.js
// module id = 867
// module chunks = 209 210 211 212